import { Injectable, Injector } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { InjectableSuperclass } from '@sama/ng-core';
import { filter } from 'rxjs/operators';
import { AbstractSensorContentStore } from '../../state/abstract-sensor-content-store';
import { AbstractLayerSettingsState } from './abstract-layer-settings-state';

@Injectable()
export abstract class AbstractLayerSettingsService<
  T extends AbstractSensorContentStore,
  L extends AbstractLayerSettingsState,
> extends InjectableSuperclass {
  protected key!: string;
  protected store: T;

  constructor(injector: Injector) {
    super();
    this.store = injector.get(AbstractSensorContentStore);

    this.subscribeTo(
      this.store('output').$.pipe(filter(isDefined)),
      (output) => {
        this.key = `layerSettings:${output.id}`;
      },
    );

    this.subscribeTo(
      this.store.getLayerSettingsStore().$.pipe(filter(isDefined)),
      (layerSettings) => {
        if (layerSettings.persist) {
          localStorage.setItem(this.key, JSON.stringify(layerSettings));
        } else {
          localStorage.removeItem(this.key);
        }
      },
    );
  }

  getInitialSettings() {
    const defaultSettings = this.getDefaultSettings();
    const asString = localStorage.getItem(this.key);
    if (asString) {
      const parsed = JSON.parse(asString) as L;
      if (parsed.version === defaultSettings.version) {
        for (const key in defaultSettings) {
          if (!isDefined(parsed[key])) {
            parsed[key] = defaultSettings[key];
          }
        }
        return parsed;
      }
    }
    return defaultSettings;
  }

  protected abstract getDefaultSettings(): L;
}
